import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { ITranscludeFunction } from 'angular';

const module = angular.module('accordion', []);

interface AccordionController extends angular.IStrictController {
    toggleContent: () => void;
    isExpanded: boolean;
    isExpandedByDefault: boolean;
    isToggleTriggerTranscludePresent: () => boolean;
    isNonToggledContentTranscludePresent: () => boolean;
}

module.component('accordion', {
    template: template,
    transclude: {
        toggleTrigger: '?toggleTrigger',
        toggledContent: 'toggledContent',
        nonToggledContent: '?nonToggledContent'
    },
    bindings: {
        isExpandedByDefault: '<'
    },
    controller: function(this: AccordionController, $transclude: ITranscludeFunction) {
        'ngInject';

        this.$onInit = () => {
            this.isExpanded = this.isExpandedByDefault;
        };

        this.toggleContent = () => {
            this.isExpanded = !this.isExpanded;
        };

        this.isToggleTriggerTranscludePresent = () => {
            return $transclude.isSlotFilled('toggleTrigger');
        };

        this.isNonToggledContentTranscludePresent = () => {
            return $transclude.isSlotFilled('nonToggledContent');
        };
    }
});

export { module };
